import { createReducer } from 'reduxsauce';
import actions from './actions';

const { Types } = actions;
const INITIAL_STATE = {
  isRequesting: false,
  popupDetails: {},
  loadingTermsAgreement: false,
  termsAgreementDetails: {},
  loadingPolicyDetails: false,
  policyDetails: {},
  loadingIpAddress: false,
  ipAddress: '',
  loadingTermsData: false,
  termsData: {},
  error: null,
};

const request = (state = INITIAL_STATE) => {
  return {
    ...state,
    isRequesting: true,
    error: null,
  };
};

const loadPopupDetailsSuccess = (state = INITIAL_STATE, { popupDetails }) => {
  return {
    ...state,
    isRequesting: false,
    popupDetails,
  };
};

const failure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isRequesting: false,
    popupDetails: {},
    error,
  };
};

const getTermsAgreementRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    loadingTermsAgreement: true,
    error: null,
  };
};

const getTermsAgreementSuccess = (state = INITIAL_STATE, { termsAgreementDetails }) => {
  return {
    ...state,
    loadingTermsAgreement: false,
    termsAgreementDetails,
  };
};

const getTermsAgreementFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    loadingTermsAgreement: false,
    termsAgreementDetails: {},
    error,
  };
};

const getPolicyDetailsRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    loadingPolicyDetails: true,
    error: null,
  };
};

const getPolicyDetailsSuccess = (state = INITIAL_STATE, { policyDetails }) => {
  return {
    ...state,
    loadingPolicyDetails: false,
    policyDetails,
  };
};

const getPolicyDetailsFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    loadingPolicyDetails: false,
    policyDetails: {},
    error,
  };
};

const getIpAddressRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    loadingIpAddress: true,
    error: null,
  };
};

const getIpAddressSuccess = (state = INITIAL_STATE, { ipAddress }) => {
  return {
    ...state,
    loadingIpAddress: false,
    ipAddress,
  };
};

const getIpAddressFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    loadingIpAddress: false,
    ipAddress: '',
    error,
  };
};

const uploadTermsDataRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    loadingTermsData: true,
    error: null,
  };
};

const uploadTermsDataSuccess = (state = INITIAL_STATE, { termsData }) => {
  return {
    ...state,
    loadingTermsData: false,
    termsData,
  };
};

const uploadTermsDataFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    loadingTermsData: false,
    termsData: {},
    error,
  };
};

export const HANDLERS = {
  [Types.LOAD_POPUP_DETAILS_REQUEST]: request,
  [Types.LOAD_POPUP_DETAILS_SUCCESS]: loadPopupDetailsSuccess,
  [Types.LOAD_POPUP_DETAILS_FAILURE]: failure,

  [Types.GET_TERMS_AGREEMENT_REQUEST]: getTermsAgreementRequest,
  [Types.GET_TERMS_AGREEMENT_SUCCESS]: getTermsAgreementSuccess,
  [Types.GET_TERMS_AGREEMENT_FAILURE]: getTermsAgreementFailure,

  [Types.GET_POLICY_DETAILS_REQUEST]: getPolicyDetailsRequest,
  [Types.GET_POLICY_DETAILS_SUCCESS]: getPolicyDetailsSuccess,
  [Types.GET_POLICY_DETAILS_FAILURE]: getPolicyDetailsFailure,

  [Types.GET_IP_ADDRESS_REQUEST]: getIpAddressRequest,
  [Types.GET_IP_ADDRESS_SUCCESS]: getIpAddressSuccess,
  [Types.GET_IP_ADDRESS_FAILURE]: getIpAddressFailure,

  [Types.UPLOAD_TERMS_DATA_REQUEST]: uploadTermsDataRequest,
  [Types.UPLOAD_TERMS_DATA_SUCCESS]: uploadTermsDataSuccess,
  [Types.UPLOAD_TERMS_DATA_FAILURE]: uploadTermsDataFailure,
};

export default createReducer(INITIAL_STATE, HANDLERS);
